// extracted by mini-css-extract-plugin
module.exports = {"injectFonts":"fonts_injectFonts__M01y5"};